<app-table (actioned)="emit($event)"
           (paginationChange)="emitPaginationChange($event)"
           [params]="tableParams" [filterText]="filterText"></app-table>
